'use strict'
var comments = angular.module('commentsModule',[
	'ui.router',
	'servicesModule',
	'ngResource',
	"ngTable",
	'ngBootstrap',
]);
require('./allcomments/js/directive/allcommentsDirective.js')(comments);
require('./allcomments/js/allcommentsController.js')(comments);
require('./allcomments/js/directive/searchCommentsDirective.js')(comments);
require('./highlightWords/js/highlightWordsController.js')(comments);
require('./highlightWords/js/directive/highlightWordsDirective.js')(comments);




//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/commentsModule/commentsModule.js
// module id = 496
// module chunks = 0